import '../layouts/stylesheets/simple-header-style.css'
import { AiOutlineDownload } from 'react-icons/ai'

const SimpleHeader = ({ downloadAction, beforeDownloadAction }) => {
  return (
    <div className="flex pt-8 justify-end items-center">
      {beforeDownloadAction}
      {downloadAction && (
        <div className="relative" onClick={downloadAction}>
          <div className="mr-8 flex justify-center items-center w-12 h-12 rounded-full border-metrinome-green-button border-2 cursor-pointer">
            <AiOutlineDownload className="h-6 w-6 text-black" />
          </div>
        </div>
      )}
    </div>
  )
}

export default SimpleHeader
